import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-input-text-email',
  templateUrl: './st-input-text-email.component.html',
  styleUrls: ['./st-input-text-email.component.scss'],
  standalone: false
})
export class StInputTextEmailComponent {

  @Input()
  label = 'Email';

  @Input()
  idVal: string = 'emailTextId';

  @Input()
  inputVal: string = '';

  @Input()
  placeHolderVal = 'Email';

  @Input()
  width?: string;

  @Input()
  maxLength: number = 40;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000';

  @Input()
  requiredVal: boolean = false;

  @Input()
  disabled: boolean = false;

  @Output()
  onClick = new EventEmitter<Event>();
}
